module.exports = __webpack_public_path__ + "static/2front-strategy-2-fd56616d072ba21c2910a404163264be.png";